'use strict';
// Third party
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/util';

//Partials

// Document Ready
(function ($) {
  let $body = $('body');

  $('.accordion-main').each(function(){
    if($(this).children().length === 0){
      $(this).parent().hide();
    }
  })

  $('.banner-container').on('click', function(){
    $([document.documentElement, document.body]).animate({
      scrollTop: $('#discounts').offset().top
    }, 500);
  });

  $('#main-nav').on('show.bs.collapse', handleNavbarToggle);
  $('#main-nav').on('hidden.bs.collapse', handleNavbarToggle);

  function handleNavbarToggle() {
    $body.toggleClass('nav-open');
  }

  function expandAll() {
    $(".action").parent().children(".accordion-main").toggleClass("active");
    $(".action").toggleClass("active");
  }

  $(".action").click(function () {
    $(this).parent().children(".accordion-main").toggleClass("active");
    $(this).toggleClass("active");
  });

  //Default Action

  $(".tab_content").hide(); //Hide all content
  $("ul.tabs li:first").addClass("active").show(); //Activate first tab
  $(".tab_content:first").show(); //Show first tab content

  //On Click Event
  $("ul.tabs li").click(function() {
    $("ul.tabs li").removeClass("active"); //Remove any "active" class
    $(this).addClass("active"); //Add "active" class to selected tab
    $(".tab_content").hide(); //Hide all tab content
    var activeTab = $(this).find("a").attr("href"); //Find the rel attribute value to identify the active tab + content
    $(activeTab).fadeIn(); //Fade in the active content
    return false;
  });
})(jQuery);
